var SchemaVersionEnum = /* @__PURE__ */ ((SchemaVersionEnum2) => {
  SchemaVersionEnum2[SchemaVersionEnum2["V0"] = 0] = "V0";
  SchemaVersionEnum2[SchemaVersionEnum2["V1"] = 1] = "V1";
  SchemaVersionEnum2[SchemaVersionEnum2["V2"] = 2] = "V2";
  SchemaVersionEnum2[SchemaVersionEnum2["V3"] = 3] = "V3";
  SchemaVersionEnum2[SchemaVersionEnum2["V4"] = 4] = "V4";
  SchemaVersionEnum2[SchemaVersionEnum2["V5"] = 5] = "V5";
  SchemaVersionEnum2[SchemaVersionEnum2["V6"] = 6] = "V6";
  SchemaVersionEnum2[SchemaVersionEnum2["V7"] = 7] = "V7";
  SchemaVersionEnum2[SchemaVersionEnum2["V8"] = 8] = "V8";
  SchemaVersionEnum2[SchemaVersionEnum2["V9"] = 9] = "V9";
  SchemaVersionEnum2[SchemaVersionEnum2["V10"] = 10] = "V10";
  SchemaVersionEnum2[SchemaVersionEnum2["V11"] = 11] = "V11";
  SchemaVersionEnum2[SchemaVersionEnum2["V12"] = 12] = "V12";
  return SchemaVersionEnum2;
})(SchemaVersionEnum || {});
export {
  SchemaVersionEnum
};
